import { useRef } from "react";
import { Tooltip } from "primereact/tooltip";
import Boton from "../boton";
import { exportarExcel } from "../../utils/exportarExcel";

// Botón de "Descargar Excel" para usar junto a cualquier tabla: exporta
// exactamente lo que recibe en `data` (ya filtrado/buscado en memoria por la
// pantalla que lo use), no vuelve a pedir nada al backend.
//
// Normalmente no se usa directo: lo muestra TablaFiltrable
// cuando se les pasa `nombreArchivo` (sin extensión). Una tabla sin
// `nombreArchivo` ni `exportar` no tiene botón.
//
// De dónde sale cada celda
// ------------------------
// Las columnas se derivan de las <Column> hijas de la tabla (ver
// utils/columnasExportables.js). Sólo se exportan las que tienen `header` con
// texto; las de acciones, sin header, se ignoran. El valor sale, en orden, de:
//   1. `exportValue` de la columna: (fila) => texto.
//   2. el texto de lo que renderiza `body`: strings y números, el texto de
//      los children, y `value` o `label` de los elementos sin children (Tag,
//      InputNumber). Un icono pi-check / pi-times o un InputSwitch salen como
//      "Sí" / "No".
//   3. `field`, que puede ser un path anidado ("norma.numero").
// Si el `body` renderiza un componente propio sin texto y la columna no tiene
// `field`, la celda sale vacía: hay que agregarle `exportValue`.
//
//   <Column
//     header="Archivo"
//     body={(a) => <ArchivoPreview nombre={a.nombredescarga} hash={a.hash} />}
//     exportValue={(a) => a.nombredescarga}
//   />
//
// Sustituir la exportación
// ------------------------
// `exportar` reemplaza la exportación por defecto cuando lo que se ve en la
// tabla no alcanza (ej. filas expandibles con más campos). Se llama con
// { data, columnas, nombreArchivo }; `data` son las filas visibles, así que
// se siguen respetando los filtros. La pantalla decide qué descargar:
//
//   - En memoria: arma sus columnas ({ header, field } o
//     { header, value: (fila, indice) => texto }) y llama a `exportarExcel`.
//     Referencia: `exportarProductos` en TarjetaProductos.js (morfeo-admin).
//   - Desde la API: llama a `downloadFile`. El estado de carga lo maneja la
//     pantalla, como con cualquier otro `downloadFile`, y lo pasa en
//     `exportando`; no se usan promesas.
//
//   const [exportando, setExportando] = useState(false);
//
//   const exportarDesdeAPI = ({ nombreArchivo }) => {
//     setExportando(true);
//     downloadFile(
//       endpoint,
//       `${nombreArchivo}.xlsx`,
//       () => setExportando(false),
//       () => setExportando(false)
//     );
//   };
//
//   <TablaFiltrable
//     conFiltros={false}
//     value={filas}
//     nombreArchivo="productos_proceso"
//     exportar={exportarDesdeAPI}
//     exportando={exportando}
//   >
export default function BotonExportarExcel({
  data,
  columnas,
  nombreArchivo,
  exportar,
  exportando,
}) {
  const contenedor = useRef(null);

  if (!exportar && !columnas?.length) return null;

  // El tooltip va en un span que envuelve al botón (y no en el botón) para
  // que también aparezca cuando está deshabilitado.
  return (
    <span
      ref={contenedor}
      data-pr-tooltip="Exportar tabla a Excel"
      data-pr-position="top"
      style={{ display: "inline-flex" }}
    >
      <Tooltip target={contenedor} />
      <Boton
        icono
        negro
        disabled={!data?.length}
        loader={exportando}
        callback={() =>
          (exportar || exportarExcel)({ data, columnas, nombreArchivo })
        }
      >
        <i
          className="pi pi-file-excel"
          style={{ fontSize: "1.5rem", color: "var(--verde)" }}
        />
      </Boton>
    </span>
  );
}
